import { controls, grouped } from "../controls";
const upload_saral_datas = {
    label: "Upload Saral Datas",
    pageLabel: "Upload Saral Datas", starting: true, url: "autogen",
    formActions: { edit: { allow: true }, delete: { allow: true } },
    pageType: "history",
    bulk: { columns: ["saral_id", "name", "fathers_name", "mothers_name", "dob", "student_class", "school_name", "village_name", "taluka_name", "udise_code"] },
    formTabs:
    {
        allTabs: [
            { label: "General", uid: "general" },
            { label: "Bulk", uid: "bulk" }
        ]
    },
    filter: [
        ...controls.displayText({ tab: "general", label: "Saral Id", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "saral_id", width: "col-sm-4", maxlength: 100, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "name", width: "col-sm-4", maxlength: 300, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Student Class", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "student_class", maxlength: 50, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "School Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "school_name", width: "col-sm-4", maxlength: 200, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Village Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "village_name", width: "col-sm-4", maxlength: 200, isReadOnly: "edit" })
    ]
    , form: [
        ...controls.displayText({ tab: "general", label: "Saral Id", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "saral_id", width: "col-sm-4", maxlength: 100, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "name", width: "col-sm-4", maxlength: 300, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Fathers Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "fathers_name", width: "col-sm-4", maxlength: 300, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Mothers Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "mothers_name", width: "col-sm-4", maxlength: 200, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Dob", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "dob", width: "col-sm-4", maxlength: 100, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Student Class", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "student_class", maxlength: 50, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "School Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "school_name", width: "col-sm-4", maxlength: 200, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Village Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "village_name", width: "col-sm-4", maxlength: 200, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Taluka Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "taluka_name", width: "col-sm-4", maxlength: 100, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "Udise Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "udise_code", width: "col-sm-4", maxlength: 100, isReadOnly: "edit" }),


    ]
    , history: {
        perPage: 10,
        reportHeader: "Upload Saral Datas",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        clickable: true,
        displayColumns: [
            { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
            { Header: "Saral Id", accessor: "saral_id", },
            { Header: "Name", accessor: "name", },
            { Header: "Fathers Name", accessor: "fathers_name", },
            { Header: "Mothers Name", accessor: "mothers_name", },
            { Header: "Dob", accessor: "dob", },
            { Header: "Student Class", accessor: "student_class", },
            { Header: "School Name", accessor: "school_name", },
            { Header: "Village Name", accessor: "village_name", },
            { Header: "Taluka Name", accessor: "taluka_name", },
        ]
    }
};
export default upload_saral_datas;